export const accordionData = [
  {
    title: "Onboarding Activity",
    points: 300,
    tasks: [
      { name: "Onboarding", points: 100, completed: true },
      { name: "Onboarding 2 activity", points: 200, completed: true },
    ],
  },
  {
    title: "Week 22",
    points: 60,
    tasks: [
      { name: "Course of Care", points: 20, completed: true },
      {
        name: "Prenatal Vitamins Daily encouraged",
        points: 30,
        completed: true,
      },
      { name: "Influenza Vaccine encouraged", points: 10, completed: true },
    ],
  },
  {
    title: "Week 28",
    points: 0,
    tasks: [
      { name: "Course of Care", points: 20, completed: true },
      {
        name: "Prenatal Vitamins Daily encouraged",
        points: 30,
        completed: true,
      },
      { name: "Influenza Vaccine encouraged", points: 10, completed: true },
    ],
  },
  {
    title: "Week 32",
    points: 0,
    tasks: [
      { name: "Course of Care", points: 20, completed: true },
      {
        name: "Prenatal Vitamins Daily encouraged",
        points: 30,
        completed: true,
      },
      { name: "Influenza Vaccine encouraged", points: 10, completed: true },
    ],
  },
  {
    title: "Week 36",
    points: 0,
    tasks: [
      { name: "Course of Care", points: 20, completed: true },
      {
        name: "Prenatal Vitamins Daily encouraged",
        points: 30,
        completed: true,
      },
      { name: "Influenza Vaccine encouraged", points: 10, completed: true },
    ],
  },
  {
    title: "Week 38+",
    points: 0,
    tasks: [
      { name: "Course of Care", points: 20, completed: true },
      {
        name: "Prenatal Vitamins Daily encouraged",
        points: 30,
        completed: true,
      },
      { name: "Influenza Vaccine encouraged", points: 10, completed: false },
    ],
  },
  {
    title: "Week 6-8",
    points: 0,
    tasks: [
      { name: "Course of Care", points: 20, completed: true },
      {
        name: "Prenatal Vitamins Daily encouraged",
        points: 30,
        completed: true,
      },
      { name: "Influenza Vaccine encouraged", points: 10, completed: true },
    ],
    completed: true,
  },
  {
    title: "Week 10-12",
    points: 0,
    tasks: [
      { name: "Course of Care", points: 20, completed: true },
      {
        name: "Prenatal Vitamins Daily encouraged",
        points: 30,
        completed: true,
      },
      { name: "Influenza Vaccine encouraged", points: 10, completed: true },
    ],
    completed: true,
  },
];

export const milestoneData = [
  {
    title: "Mommy Member",
    description: "You have earned 100 points by onboarding as Mommy Member",
    points: 100,
    isCompleted: true,
    color: "#06A3B0",
  },
  {
    title: "Tummy Trailblazers",
    description: "You have earned 500 points by Reaching Tummy Trailblazers",
    points: 500,
    isCompleted: true,
    color: "#CF489A",
  },
  {
    title: "Glow Getters",
    description: "You can earn 1000 points by completing Glow Getters",
    points: 1000,
    isCompleted: false,
    color: "#A41E35",
  },
  {
    title: "Bump Bosses",
    description: "You can earn 2000 points by completing Bump Bosses",
    points: 2000,
    isCompleted: false,
    color: "#FDB913",
  },
];

// export const displayGroups = [
//   {
//     displayGroupId: 1,
//     displayGroupDisplayName: "Enrollment",
//     trimesterId: null,
//     displayGroupSequence: 0,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "",
//     trimesterDisplayName: "",
//     trimesterDisplaySequence: null,
//     isTrimesterActive: null,
//   },
//   {
//     displayGroupId: 2,
//     displayGroupDisplayName: "Week 6-8",
//     trimesterId: 1,
//     displayGroupSequence: 1,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "1st Trimester",
//     trimesterDisplayName: "First Trimester",
//     trimesterDisplaySequence: 1,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 3,
//     displayGroupDisplayName: "Week 10-12",
//     trimesterId: 1,
//     displayGroupSequence: 2,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "1st Trimester",
//     trimesterDisplayName: "First Trimester",
//     trimesterDisplaySequence: 1,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 4,
//     displayGroupDisplayName: "Week 16-18",
//     trimesterId: 2,
//     displayGroupSequence: 3,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "2nd Trimester",
//     trimesterDisplayName: "Second Trimester",
//     trimesterDisplaySequence: 2,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 5,
//     displayGroupDisplayName: "Week 20",
//     trimesterId: 2,
//     displayGroupSequence: 4,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "2nd Trimester",
//     trimesterDisplayName: "Second Trimester",
//     trimesterDisplaySequence: 2,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 6,
//     displayGroupDisplayName: "Week 24",
//     trimesterId: 3,
//     displayGroupSequence: 5,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 7,
//     displayGroupDisplayName: "Week 28",
//     trimesterId: 3,
//     displayGroupSequence: 6,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 8,
//     displayGroupDisplayName: "Week 32",
//     trimesterId: 3,
//     displayGroupSequence: 7,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 9,
//     displayGroupDisplayName: "Week 36",
//     trimesterId: 3,
//     displayGroupSequence: 8,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 10,
//     displayGroupDisplayName: "Week 37",
//     trimesterId: 3,
//     displayGroupSequence: 9,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 11,
//     displayGroupDisplayName: "Week 38",
//     trimesterId: 3,
//     displayGroupSequence: 10,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 12,
//     displayGroupDisplayName: "Week 39",
//     trimesterId: 3,
//     displayGroupSequence: 11,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 13,
//     displayGroupDisplayName: "Week 40",
//     trimesterId: 3,
//     displayGroupSequence: 12,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 14,
//     displayGroupDisplayName: "Postpartum",
//     trimesterId: 3,
//     displayGroupSequence: 13,
//     isMilestone: 1,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "3rd Trimester",
//     trimesterDisplayName: "Third Trimester",
//     trimesterDisplaySequence: 3,
//     isTrimesterActive: true,
//   },
//   {
//     displayGroupId: 15,
//     displayGroupDisplayName: "General Activity",
//     trimesterId: null,
//     displayGroupSequence: 21,
//     isMilestone: 0,
//     isDisplayGroupActive: false,
//     trimesterDisplayName: "",
//     trimesterDisplayName: "",
//     trimesterDisplaySequence: null,
//     isTrimesterActive: null,
//   },
//   {
//     displayGroupId: 16,
//     displayGroupDisplayName: "General Education",
//     trimesterId: null,
//     displayGroupSequence: 22,
//     isMilestone: 0,
//     isDisplayGroupActive: true,
//     trimesterDisplayName: "",
//     trimesterDisplayName: "",
//     trimesterDisplaySequence: null,
//     isTrimesterActive: null,
//   },
// ];

export const taskTypes = [
  {
    taskTypeId: 3,
    taskTypeName: "Education",
    taskTypeDisplayName: "Education",
    taskTypeIcon: "TaskTypeIcon",
    shortDescription: "Education",
    longDescription: "Education",
  },
  {
    taskTypeId: 4,
    taskTypeName: "Enrollment",
    taskTypeDisplayName: "Enrollment",
    taskTypeIcon: "TaskTypeIcon",
    shortDescription: "Enrollment",
    longDescription: "Enrollment",
  },
  {
    taskTypeId: 2,
    taskTypeName: "Order",
    taskTypeDisplayName: "Order",
    taskTypeIcon: "TaskTypeIcon",
    shortDescription: "Order",
    longDescription: "Order",
  },
  {
    taskTypeId: 5,
    taskTypeName: "Tier Bonus",
    taskTypeDisplayName: "TierBonus",
    taskTypeIcon: "TaskTypeIcon",
    shortDescription: "TierBonus",
    longDescription: "TierBonus",
  },
  {
    taskTypeId: 1,
    taskTypeName: "Visit",
    taskTypeDisplayName: "Visit",
    taskTypeIcon: "TaskTypeIcon",
    shortDescription: "Visit",
    longDescription: "Visit",
  },
];

export const categoryWiseStatus = [
  {
    statusId: 1,
    statusName: "Default",
    statusDisplayName: "Default",
    categoryId: 1,
    categoryName: "Default",
    categoryDisplayName: "Default",
  },
  {
    statusId: 2,
    statusName: "Not Started",
    statusDisplayName: "Not Started",
    categoryId: 5,
    categoryName: "Display Group",
    categoryDisplayName: "Display Group",
  },
  {
    statusId: 3,
    statusName: "Not Applicable",
    statusDisplayName: "Not Applicable",
    categoryId: 5,
    categoryName: "Display Group",
    categoryDisplayName: "Display Group",
  },
  {
    statusId: 4,
    statusName: "In Progress",
    statusDisplayName: "In Progress",
    categoryId: 5,
    categoryName: "Display Group",
    categoryDisplayName: "Display Group",
  },
  {
    statusId: 5,
    statusName: "Completed",
    statusDisplayName: "Completed",
    categoryId: 5,
    categoryName: "Display Group",
    categoryDisplayName: "Display Group",
  },
  {
    statusId: 6,
    statusName: "Partially Completed",
    statusDisplayName: "Partially Completed",
    categoryId: 5,
    categoryName: "Display Group",
    categoryDisplayName: "Display Group",
  },
  {
    statusId: 7,
    statusName: "Completed",
    statusDisplayName: "Completed",
    categoryId: 6,
    categoryName: "Case Task",
    categoryDisplayName: "Case Task",
  },
  {
    statusId: 8,
    statusName: "Not Started",
    statusDisplayName: "Not Started",
    categoryId: 6,
    categoryName: "Case Task",
    categoryDisplayName: "Case Task",
  },
  {
    statusId: 9,
    statusName: "Missed",
    statusDisplayName: "Missed",
    categoryId: 6,
    categoryName: "Case Task",
    categoryDisplayName: "Case Task",
  },
  {
    statusId: 10,
    statusName: "Eligible",
    statusDisplayName: "Eligible",
    categoryId: 7,
    categoryName: "Enrollment",
    categoryDisplayName: "Enrollment",
  },
  {
    statusId: 11,
    statusName: "Enroll",
    statusDisplayName: "Enroll",
    categoryId: 7,
    categoryName: "Enrollment",
    categoryDisplayName: "Enrollment",
  },
  {
    statusId: 12,
    statusName: "Declined Consent",
    statusDisplayName: "Declined Consent",
    categoryId: 7,
    categoryName: "Enrollment",
    categoryDisplayName: "Enrollment",
  },
  {
    statusId: 13,
    statusName: "Opt Out",
    statusDisplayName: "Opt Out",
    categoryId: 7,
    categoryName: "Enrollment",
    categoryDisplayName: "Enrollment",
  },
  {
    statusId: 14,
    statusName: "Fetal Loss",
    statusDisplayName: "Fetal Loss",
    categoryId: 7,
    categoryName: "Enrollment",
    categoryDisplayName: "Enrollment",
  },
  {
    statusId: 15,
    statusName: "Delivered and pending Redemption",
    statusDisplayName: "Delivered and pending Redemption",
    categoryId: 7,
    categoryName: "Enrollment",
    categoryDisplayName: "Enrollment",
  },
  {
    statusId: 16,
    statusName: "Delivered and Points Expired",
    statusDisplayName: "Delivered and Points Expired",
    categoryId: 7,
    categoryName: "Enrollment",
    categoryDisplayName: "Enrollment",
  },
  {
    statusId: 17,
    statusName: "Delivered and redeemed",
    statusDisplayName: "Delivered and redeemed",
    categoryId: 7,
    categoryName: "Enrollment",
    categoryDisplayName: "Enrollment",
  },
  {
    statusId: 18,
    statusName: "Active",
    statusDisplayName: "Active",
    categoryId: 8,
    categoryName: "Admin Profile",
    categoryDisplayName: "Admin Profile",
  },
  {
    statusId: 19,
    statusName: "Inactive",
    statusDisplayName: "Inactive",
    categoryId: 8,
    categoryName: "Admin Profile",
    categoryDisplayName: "Admin Profile",
  },
  {
    statusId: 20,
    statusName: "OnHold",
    statusDisplayName: "OnHold",
    categoryId: 8,
    categoryName: "Admin Profile",
    categoryDisplayName: "Admin Profile",
  },
  {
    statusId: 21,
    statusName: "Ready to Redeem",
    statusDisplayName: "Ready to Redeem",
    categoryId: 11,
    categoryName: "Redemption",
    categoryDisplayName: "Redemption",
  },
  {
    statusId: 22,
    statusName: "Redeemed",
    statusDisplayName: "Redeemed",
    categoryId: 11,
    categoryName: "Redemption",
    categoryDisplayName: "Redemption",
  },
  {
    statusId: 23,
    statusName: "Expired",
    statusDisplayName: "Expired",
    categoryId: 11,
    categoryName: "Redemption",
    categoryDisplayName: "Redemption",
  },
  {
    statusId: 24,
    statusName: "Draft",
    statusDisplayName: "Draft",
    categoryId: 12,
    categoryName: "Task",
    categoryDisplayName: "Task",
  },
  {
    statusId: 25,
    statusName: "Created",
    statusDisplayName: "Created",
    categoryId: 12,
    categoryName: "Task",
    categoryDisplayName: "Task",
  },
  {
    statusId: 26,
    statusName: "Approved",
    statusDisplayName: "Approved",
    categoryId: 12,
    categoryName: "Task",
    categoryDisplayName: "Task",
  },
  {
    statusId: 27,
    statusName: "Active",
    statusDisplayName: "Active",
    categoryId: 12,
    categoryName: "Task",
    categoryDisplayName: "Task",
  },
  {
    statusId: 28,
    statusName: "Deactivated",
    statusDisplayName: "Deactivated",
    categoryId: 12,
    categoryName: "Task",
    categoryDisplayName: "Task",
  },
  {
    statusId: 29,
    statusName: "Re-Created",
    statusDisplayName: "Re-Created",
    categoryId: 12,
    categoryName: "Task",
    categoryDisplayName: "Task",
  },
  {
    statusId: 30,
    statusName: "Alive",
    statusDisplayName: "Alive",
    categoryId: 13,
    categoryName: "Patient Living",
    categoryDisplayName: "Patient Living",
  },
  {
    statusId: 31,
    statusName: "Deceased",
    statusDisplayName: "Deceased",
    categoryId: 13,
    categoryName: "Patient Living",
    categoryDisplayName: "Patient Living",
  },
  {
    statusId: 32,
    statusName: "Active",
    statusDisplayName: "Active",
    categoryId: 15,
    categoryName: "Episode",
    categoryDisplayName: "Episode",
  },
  {
    statusId: 33,
    statusName: "Resolved",
    statusDisplayName: "Resolved",
    categoryId: 15,
    categoryName: "Episode",
    categoryDisplayName: "Episode",
  },
  {
    statusId: 34,
    statusName: "Deleted",
    statusDisplayName: "Deleted",
    categoryId: 15,
    categoryName: "Episode",
    categoryDisplayName: "Episode",
  },
  {
    statusId: 41,
    statusName: "Enrollmentpending",
    statusDisplayName: "Enrollmentpending",
    categoryId: 16,
    categoryName: "Patient Case",
    categoryDisplayName: "Patient Case",
  },
  {
    statusId: 42,
    statusName: "Active",
    statusDisplayName: "Active",
    categoryId: 16,
    categoryName: "Patient Case",
    categoryDisplayName: "Patient Case",
  },
  {
    statusId: 43,
    statusName: "Inactive",
    statusDisplayName: "Inactive",
    categoryId: 16,
    categoryName: "Patient Case",
    categoryDisplayName: "Patient Case",
  },
  {
    statusId: 44,
    statusName: "Journey Completion",
    statusDisplayName: "Journey Completion",
    categoryId: 16,
    categoryName: "Patient Case",
    categoryDisplayName: "Patient Case",
  },
];

export const educationalContentTypes = [
  {
    educationalContentTypeId: 1,
    contentTypeName: "videos",
    contentTypeDisplayName: "Video",
    isActive: true,
  },
  {
    educationalContentTypeId: 2,
    contentTypeName: "articles",
    contentTypeDisplayName: "Article",
    isActive: true,
  },
  {
    educationalContentTypeId: 3,
    contentTypeName: "URL",
    contentTypeDisplayName: "URL",
    isActive: true,
  },
];

export const activeLanguages = [
  {
    languageId: 1,
    languageName: "English",
    languageCode: "en",
  },
  {
    languageId: 2,
    languageName: "Spanish",
    languageCode: "es",
  },
  {
    languageId: 3,
    languageName: "Russian",
    languageCode: "ru",
  },
];
